import { Select } from 'antd';

import {
  CHART_GRAPH,
  ChartGraphListByChartType,
} from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import {
  ChartGraphDirectionMap,
  ChartGraphMap,
} from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  chartInfo: ChartContextProps;
};

const directionEnabledGraphList = [
  CHART_GRAPH.BAR,
  CHART_GRAPH.BAR_STACKED,
  CHART_GRAPH.LINE,
  CHART_GRAPH.AREA_STACKED,
];

export const CustomChartController = (props: Props) => {
  const { chartInfo } = props;
  const { state } = chartInfo;
  const { onGraphChange, onGraphDirectionChange } =
    useChartStateAction(chartInfo);

  const graphOptions = ChartGraphListByChartType[state.type]
    .filter((g) => g !== CHART_GRAPH.COMBO_CHART)
    .map((graph) => ({
      label: ChartGraphMap.get(graph),
      value: graph,
    }));

  const directionOptions = ChartGraphDirectionMap.toArray();

  const showDirectionSelect = directionEnabledGraphList.includes(state.graph);

  return (
    <div className="flex gap-3 flex-wrap">
      <Select
        className="w-32"
        options={graphOptions}
        value={state.graph}
        onChange={onGraphChange}
      />
      {showDirectionSelect && (
        <Select
          className="w-28"
          options={directionOptions}
          value={state.graph_direction}
          onChange={onGraphDirectionChange}
        />
      )}
    </div>
  );
};
